import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const ReadinessClosing = () => (
  <section className="readiness-paper py-24 md:py-32" data-testid="readiness-closing-section">
    <div className="readiness-shell grid gap-10 border-t border-[#173f42]/15 pt-16 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-8">
        <p className="readiness-kicker" data-testid="readiness-closing-eyebrow">A more honest beginning</p>
        <h2 className="mt-7 max-w-4xl font-serif text-5xl leading-[0.95] text-[#173f42] md:text-7xl" data-testid="readiness-closing-title">Renew your mind. <em className="font-normal">Reclaim your life.</em></h2>
        <p className="mt-7 max-w-2xl text-base leading-8 text-[#52625c]" data-testid="readiness-closing-copy">Lasting transformation does not begin with more pressure. It begins with truth, compassion, and a clear understanding of where you are today.</p>
      </div>
      <div className="lg:col-span-4 lg:text-right">
        <Link to="/assessment" className="readiness-primary-button inline-flex items-center gap-6 px-6 py-4 text-sm font-semibold" data-testid="readiness-closing-assessment-cta">Begin my assessment <ArrowRight size={17} /></Link>
      </div>
    </div>
  </section>
);